import Icon from 'veui/components/Icon'
import { IconCheckCircleSolid } from 'dls-icons-vue'

Icon.register('check-circle-solid', IconCheckCircleSolid)
